import { MainThunkDispatch } from "../../../Reducers"
import { StatisticsState } from "../../../Reducers/API/Statistics/StatisticsReducer"
import { apiEndpoints } from "../../../Routes/api"
import { failMessage } from "../../Client/MessagesActions"
import { apiFetch } from "../../Client/NetworkActions"
import { StatisticsType } from "../../Types"

export const getStatisticsSnapshot =
    (appID: string) => async (dispatch: MainThunkDispatch) => {
        try {
            const endpoint = apiEndpoints.getStatisticsSnapshot({ appID })
            const response = await dispatch(
                apiFetch<StatisticsState>(endpoint.url, endpoint)
            )

            if (response !== undefined) {
                dispatch({
                    type: StatisticsType.getStatisticsSnapshot,
                    payload: response
                })
            }
        } catch (error) {
            dispatch(failMessage("Failed to load statistics."))
        }
    }
